export enum FormLoadState {
  Idle = 'Idle',
  Submitting = 'Submitting',
  Failure = 'Failure',
  Success = 'Success',
}

export interface FormRootState<P> {
  requestPayload: P;
  loadState: FormLoadState;
}
